import { HttpClient } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { Observable } from "rxjs";
import { CommonWebService, CompanyForumComment, CompanyForumListing, CompanyForumReplyComment, DEVICE_CREDENTIALS, HttpResponse, UserHttpService } from "../public-api";

@Injectable({
  providedIn: "root",
})
export class CompanyForumService {
    
  constructor(
    private http: HttpClient,
    private userService: UserHttpService,
    private commonService: CommonWebService
  ) {}

  public getForumListing(): Observable<HttpResponse<CompanyForumListing[]>> {
    let formData = new FormData();
    formData.append('deviceToken', DEVICE_CREDENTIALS.DEVICE_TOKEN);
    formData.append('deviceType', DEVICE_CREDENTIALS.DEVICE_TYPE);
    formData.append('user_id', this.userService.getUserInfo.user_id);
    formData.append('usr_role_track_id', this.userService.getUserInfo.usr_role_track_id);
    formData.append('token', this.userService.userToken);
    formData.append('customer_id', this.userService.getUserInfo.usr_customer_track_id);
    return this.http.post<HttpResponse<CompanyForumListing[]>>('forum/listCommentForum', formData);
  }

  public sendComment(body: CompanyForumComment): Observable<HttpResponse<any>> {
    let formData = new FormData();
    formData.append('deviceToken', DEVICE_CREDENTIALS.DEVICE_TOKEN);
    formData.append('deviceType', DEVICE_CREDENTIALS.DEVICE_TYPE);
    formData.append('user_id', this.userService.getUserInfo.user_id);
    formData.append('usr_role_track_id', this.userService.getUserInfo.usr_role_track_id);
    formData.append('token', this.userService.userToken);
    formData.append('customer_id', this.userService.getUserInfo.usr_customer_track_id);
    formData.append('comment_msg', body.comment_msg ? body.comment_msg : "");

    if(body.file_upload) {
      formData.append('file_upload', body.file_upload ? this.commonService.getFormattedImageBase64(body.file_upload) : "");
    }
    return this.http.post<HttpResponse<any>>('forum/addCommentForum', formData);
  }

  public replyComment(body: CompanyForumReplyComment): Observable<HttpResponse<any>> {
    let formData = new FormData();
    formData.append('deviceToken', DEVICE_CREDENTIALS.DEVICE_TOKEN);
    formData.append('deviceType', DEVICE_CREDENTIALS.DEVICE_TYPE);
    formData.append('user_id', this.userService.getUserInfo.user_id);
    formData.append('usr_role_track_id', this.userService.getUserInfo.usr_role_track_id);
    formData.append('token', this.userService.userToken);
    formData.append('comment_id', body.comment_id ? body.comment_id : "");
    formData.append('reply_msg', body.reply_msg ? body.reply_msg : "");
    return this.http.post<HttpResponse<any>>('forum/addReplyForum', formData);
  }



}
